import { render } from "./GlitchBackground.vue?vue&type=template&id=73384696&scoped=true"
import script from "./GlitchBackground.vue?vue&type=script&lang=js"
export * from "./GlitchBackground.vue?vue&type=script&lang=js"

import "./GlitchBackground.vue?vue&type=style&index=0&id=73384696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73384696"]])

export default __exports__